import { useApiQuery } from './useApiQuery';
import { useApiMutation } from './useApiMutation';
import { whatsNewApi, type WhatsNewRelease } from '../lib/api/whatsNew';
import { log } from '@/lib/logger';

log.info('[useWhatsNew] Module loaded');

/**
 * The current release to pop as a modal (or null). staleTime: 0 so a fresh
 * sign-in / refresh always re-checks server-side read state (a second device
 * may have dismissed it).
 */
export function useCurrentWhatsNew() {
  return useApiQuery<WhatsNewRelease | null>({
    queryKey: ['whats-new', 'current'],
    queryFn: (token) => whatsNewApi.getCurrent(token),
    staleTime: 0,
  });
}

/** Marks a release (and older modal-eligible ones) read. No cache invalidation:
 *  the modal closes on success and /current is not shown again this session. */
export function useMarkWhatsNewRead() {
  return useApiMutation<{ ok: true }, string>({
    mutationFn: (token, id) => whatsNewApi.markRead(token, id),
  });
}
